import React from "react";
import { Container } from "react-bootstrap";
import { FaFacebook, FaInstagram } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="py-4 mt-5 border-top" style={{ background: "#eaf8f5" }}>
      <Container
        className="text-center"
        style={{
          borderRadius: "12px",
          padding: "1rem",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.05)",
        }}
      >
        <p className="mb-2 text-muted">
          © {new Date().getFullYear()} Sanus Esthetic. Todos los derechos
          reservados.
        </p>
        <div>
          <a
            href="https://www.instagram.com/sanus.esthetic/?igsh=MXEzY2V5M210NjM3cQ%3D%3D#"
            target="_blank"
            rel="noopener noreferrer"
            className="me-3 text-dark"
          >
            <FaInstagram size={24} />
          </a>
          <a
            href="https://www.facebook.com/people/Sanus-Esthetic/100076025207072/#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark"
          >
            <FaFacebook size={24} />
          </a>
        </div>
      </Container>
    </footer>
  );
}
